export default __webpack_public_path__ + "static/media/matatag.8a6d0846.png";